import React from 'react';
import _ from 'lodash';
import ArticleLink from '../ArticleLink.jsx';
import FeedContainerSimple from './FeedContainerSimple.jsx';
import { connect } from 'react-redux';
import RowWithTwo from './RowWithTwo.jsx';
import FeedContainerSmall from './FeedContainerSmall.jsx';

export default class FeedContainerBox extends React.PureComponent {
  render() {
    const { contentContainers, limit } = this.props;
    const articles = _.slice(contentContainers, 0, limit);

    return (
      <div className="row">
        <div className="template-item col-md-12">
          <div className="popular-videos">
	              <h3 className="box-title">Redaktionen anbefaler</h3>
		          {
		            articles.map(article => {
		              return (
					 <div key={article.id} className={`template-item col-xs-6 box_css`}>
		                 <FeedContainerSmall contentContainer={article} />
		             </div>
		
		              );
		            })
		          }
        </div>
      </div>
      </div>
    );
  }
}

FeedContainerBox.propTypes = {
  limit: React.PropTypes.number,
  contentContainers: React.PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/component/NewsFeed/FeedContainerBox.jsx